import { useQuery } from "@tanstack/react-query";
import api from "../../api";
import { Drill } from "../../domains/Drill";
import { createError, HTTPErrors } from "../../errors";
import SectionInterface from "../../interfaces/SectionInterface";

type Props = {
  section: SectionInterface;
  materialCode?: string;
};
type DrillResponse = {
  drill: Drill;
};
export const useFetchDrillDetail = (props: Props) => {
  return useQuery<Drill, HTTPErrors>({
    queryKey: ["drills", props.section.id, props.materialCode],
    queryFn: async () => {
      const res = await api.get(
        `/api/v1/sections/${props.section.id}/drill_learning_materials/${props.materialCode}`,
      );

      if (res.status === 200) {
        const json: DrillResponse = await res.json();
        return json.drill;
      }

      throw await createError(res);
    },
    retry: 0, // 404の場合はリトライしたくないので
    enabled: props.materialCode !== undefined,
  });
};
